import { combineReducers } from 'redux'

import initialState from 'app_modules/store/initialState.json'

import notificationsActionTypes from 'app_modules/notifications/constants'
import profileActionTypes from 'app_modules/profile/constants'
import sessionActionTypes from 'app_modules/session/constants'

export const bar = (state = initialState.notifications.bar, action) => {
  const { type: actionType, payload } = action

  switch (actionType) {
    case notificationsActionTypes.ADD_BAR_NOTIFICATION:
      return {
        currentNotification: payload,
        remainingNotifications: [...state.remainingNotifications, payload],
      }

    case notificationsActionTypes.CLEAR_BAR_NOTIFICATION:
      return {
        currentNotification: {},
        remainingNotifications: [],
      }

    case sessionActionTypes.RESET_STATE:
      return initialState.notifications.bar

    default:
      return state
  }
}

export const modal = (state = initialState.notifications.modal, action) => {
  const { type: actionType, payload } = action
  switch (actionType) {
    case notificationsActionTypes.ADD_MODAL_NOTIFICATION:
      return {
        ...payload,
        open: true,
      }

    case notificationsActionTypes.CLEAR_MODAL_NOTIFICATION:
      return {
        options: {},
        open: false,
      }

    case sessionActionTypes.RESET_STATE:
      return initialState.notifications.modal

    default:
      return state
  }
}

// E3a — Working Circle Notifications
// State shape: { isFetching, isDismissing, items }
// Each item: { type: 'reciprocal'|'social_overlap', connectionId, profile, sharedCount }
export const workingCircle = (state = initialState.notifications.workingCircle, action) => {
  const { type: actionType, payload } = action

  switch (actionType) {
    case notificationsActionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS_REQUEST:
      return { ...state, isFetching: true }

    case notificationsActionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        // API returns { notifications: [...] }; keys are camelCased by ApiEndpoint.
        items: payload.notifications || [],
      }

    case notificationsActionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS_FAILURE:
      return { ...state, isFetching: false }

    case profileActionTypes.FETCH_ADD_WORKING_CIRCLE_MEMBER_SUCCESS:
      // When a profile is added to the working circle, remove their social_overlap notification
      // immediately — they are no longer an "outside" suggestion.
      return {
        ...state,
        items: state.items.filter(item => !(item.type === 'social_overlap' && item.id === payload.member?.id)),
      }

    case notificationsActionTypes.DISMISS_SOCIAL_OVERLAP_NOTIFICATION:
      // Remove the dismissed social_overlap item from Redux items immediately.
      // localStorage is written by the component before dispatching this action.
      return {
        ...state,
        items: state.items.filter(item => !(item.type === 'social_overlap' && item.id === payload.id)),
      }

    case notificationsActionTypes.FETCH_DISMISS_NOTIFICATION_REQUEST:
      return { ...state, isDismissing: true }

    case notificationsActionTypes.FETCH_DISMISS_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isDismissing: false,
        // Remove the dismissed notification from the list immediately — no refetch needed.
        items: state.items.filter(item => item.connectionId !== payload.connectionId),
      }

    case notificationsActionTypes.FETCH_DISMISS_NOTIFICATION_FAILURE:
      return { ...state, isDismissing: false }

    case sessionActionTypes.RESET_STATE:
      return initialState.notifications.workingCircle

    default:
      return state
  }
}

export default combineReducers({
  bar,
  modal,
  workingCircle,
})
